module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('Layout_Promo', {

		configure: function(options) {
			this.registerOptions('', {
				widgets: {
					throughNotifications: {
						widget: 'ThroughNotifications',
						doNotTrackPosNote: true
					},
						
					header: {
						widget: 'Widget',
						autoRender: true,
						embed: {
							container: '.header-container',
							location: 'firstChild'
						},
						template: 'promo_header',
						handleDom: {
							menuOpen: {
								target: '.menu-open',
								event: 'click',
								callback: '@parent:toggleMenu'
							},
							menuClose: {
								target: '.menu-close',
								event: 'click',
								callback: '@parent:toggleMenu'
							},
							menuClick: {
								target: '.menu-link',
								event: 'click',
								callback: '@parent:toggleMenu'
							}
						},
						handleWom: {
							addToDom: {
								event: 'addedToDom',
								widget: '@this',
								callback: '@parent:initHeader'
							}
						}
					},
					footer: {
						widget: 'Widget',
						autoRender: true,
						container: '#promo-footer',
						template: 'promo_footer',
						templateOptions: {
							year: new Date().getFullYear()
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		initHeader: function() {
			var header = this.dom1('#promo-header');
			this.headerWrap = header;

			var transitionEvent = this.whichTransitionEvent();
			header.addEventListener(transitionEvent, function(el) {
				if (!fox.dom.hasClass('open', el.target)) {
					fox.dom.removeClass('bgc', el.target);
				}
			}, false);
		},

		whichTransitionEvent: function() {
			var t,
				el = this.headerWrap;

			var transitions = {
				"transition"      : "transitionend",
				"OTransition"     : "oTransitionEnd",
				"MozTransition"   : "transitionend",
				"WebkitTransition": "webkitTransitionEnd"
			};

			for (t in transitions){
				if (el.style[t] !== undefined){
					return transitions[t];
				}
			}
		},

		toggleMenu: function(el, alias, w, e) {
			fox.dom.event.stop(e);

			if (alias === 'menuOpen') {
				fox.dom.addClass('open', this.headerWrap);
				fox.dom.addClass('bgc', this.headerWrap);
			} else {
				fox.dom.removeClass('open', this.headerWrap);
			}
		}

	}, 'Site_Layout');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/layout/promo.js
// module id = 196
// module chunks = 5